import MaturityScale from "./MaturityScale";

function SmallBarChart({ value, maturityScale, lavel }) {

  console.log('value', Math.round(value));

  const options = [
    { value: 1, label: 'Initiating', Highlabel: 'Not at all Important' },
    { value: 2, label: 'Emerging', Highlabel: 'Low Importance' },
    { value: 3, label: 'Performing', Highlabel: 'Moderately Important' },
    { value: 4, label: 'Advancing', Highlabel: 'Highly Important' },
    { value: 5, label: 'Leading', Highlabel: 'Critically Important' },
  ];


  const getHighLevelLabel = (value) => {
    const found = options.find((opt) => opt.value === Math.round(value));
    return found ? found.Highlabel : 0;
  };


  return (
    <>
      <div className="small_bar_chart">
        <div className="bar-chart">
          {[1, 2, 3, 4, 5].map((level) => (
            <div
              key={level}
              className={`bar ${level === Math.round(value) ? 'filled' : ''}`}
              style={{ height: `${level * 10}px` }}
            ></div>
          ))}


        </div>
        <p>
          {Math.round(value) > 0.5
            ? `${getHighLevelLabel(Math.round(value))} (${Math.round(value)})`
            : value.toFixed(3)}
        </p>
        {maturityScale && (
          <MaturityScale lableValue={true} currentLevel={lavel.current} targetLevel={lavel.future} optionLable={false} />
        )}
      </div>
    </>

  );
}

export default SmallBarChart;